import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fileNameDate',
	standalone: true
})
export class FileNameDatePipe implements PipeTransform {

	private padWithZero(value: number): string {
		return value.toString().padStart(2, '0');
	}

	transform(input: string): string {
		const now = new Date();
		
		const year = now.getFullYear();
		const month = this.padWithZero(now.getMonth() + 1); // Month is 0-indexed
		const day = this.padWithZero(now.getDate());
		const hour = this.padWithZero(now.getHours());
		const minute = this.padWithZero(now.getMinutes());

		const formattedDate = `${year}_${month}_${day}_${hour}_${minute}`;
		
		return `${input}_${formattedDate}`;
	}
}